<template>
  <div :class="'property-search-page filterDisable'">
    <base-breadcrumb-bar
      :tabItems="tabs"
      :tab.sync="tab"
      :pageTitle="'Search properties'"
    >
      <template v-slot:filterBlock> </template>
    </base-breadcrumb-bar>

    <div v-if="tab == 0">
      <google-map
        :initial="propertiesData"
        :loading.sync="loading"
        :maxPropertiesFound="maxPropertiesFound"
        :outerProperty="propertyOptions.areas"
        :areas.sync="propertyOptions.areas"
        :searchedName.sync="searchedName"
        :propFilters="superPropertyFilter"
        :zoom="zoom"
      >
      </google-map>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import PropertyFilter from "@/components/Base/Property/PropertyFilter.vue";
import PropertyUnitBuildTable from "@/components/Base/Property/PropertyUnitBuildTable.vue";
import GoogleMap from "@/components/Base/GoogleMaps/GoogleMapsTemp.vue";
import PropertyGroupedHq from "@/components/Base/Property/PropertyGroupedHQ";

import {
  GET_PROPERTIES_FOR_MAP,
  GET_PROPERTIES_COUNTS,
  GET_PROPERTY_IDS_FROM_REFS,
} from "@/queries/property";

import { gql } from "apollo-boost";
export default {
  components: {
    PropertyFilter,
    PropertyUnitBuildTable,
    GoogleMap,
    PropertyGroupedHq,
  },
  props: {
    id: {
      type: [String, Array],
      default: null,
    },
  },
  name: "PropertySearch",
  data() {
    return {
      propertyOptions: {},
      buildingOptions: {},
      unitOptions: {},
      propertyIDFound: null,
      maxPropertiesFound: null,

      propertiesData: [],

      finalBuildingFilters: null,
      finalUnitFilters: null,

      loading: false,
      loadingProperty: false,

      superPropertyFilter: {},
      superProRefFilter: {
        units: null,
        buildings: null,
        hqnames: null,
        portal: null,
      },
      combined: {
        properties: null,
        units: null,
        buildings: null,
        hqnames: null,
        portal: null,
      },
      getProps: false,
      getPropsFromRef: false,

      tabs: [{ text: "Map Search", icon: "mdi-earth" }],

      tab: 0,
      groupByOwner: false,
      pickedHQs: [],
      getUnitsTable: null,
      searchedName: false,
      zoom: 6,
      skipPropety: true,
      skipUnits: true,
      forSaleTab2: null,
      toLetTab2: null,
    };
  },
  apollo: {},

  methods: {
    async fetchPropertiesFilters() {
      try {
        let filter = { ...this.propertyOptions };

        if (Object.values(filter).length > 0) {
          filter[`$and`] = [];
        }
        this.searchedName = false;
        if (filter.text?.length > 0) {
          var testString = [
            { name: { $regex: filter.text, $options: "i" } },
            { address: { $regex: filter.text, $options: "i" } },
          ];

          filter[`$and`].push({ $or: testString });
          this.searchedName = true;

          this.combined.hqnames = {
            name: { $regex: filter.text, $options: "i" },
          };
        } else {
          this.combined.hqnames = null;
        }
        delete filter[`text`];

        if (filter.erfSize) {
          filter.erfSize = {
            $gte: filter.erfSize?.min ? parseFloat(filter.erfSize?.min) : 0,
            $lte: filter.erfSize?.max
              ? parseFloat(filter.erfSize?.max)
              : 99999999999,
          };
        } else {
          delete filter[`erfSize`];
        }

        if (filter.propertyType && filter.propertyType?.length > 0) {
          var propTypeSet = [];
          if (filter.propertyType.includes("Null")) {
            propTypeSet.push(
              { propertyType: "" },
              { propertyType: null },
              { propertyType: { $exists: false } }
            );
          }

          const nonNullOptions = filter.propertyType.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions.length > 0) {
            propTypeSet.push({ propertyType: { $in: nonNullOptions } });
          }

          filter[`$and`].push({ $or: propTypeSet });
          delete filter[`propertyType`];
        } else {
          delete filter[`propertyType`];
        }

        if (filter.areas?.length > 0)
          filter[`$and`].push({ areas: { $in: filter.areas } }); // filter.areas = { $in: filter.areas };
        //else
        delete filter[`areas`];

        if (!filter.erfNo) {
          delete filter[`erfNo`];
        }

        if (filter.zoning && filter.zoning?.length > 0) {
          var zoningSet = [];
          if (filter.zoning.includes("Null")) {
            zoningSet.push(
              { zoning: "" },
              { zoning: null },
              { zoning: { $exists: false } }
            );
          }

          const nonNullOptions2 = filter.zoning.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions2.length > 0) {
            zoningSet.push({ zoning: { $in: nonNullOptions2 } });
          }

          filter[`$and`].push({ $or: zoningSet });
          delete filter[`zoning`];
        } else {
          delete filter[`zoning`];
        }

        if (filter.ownershipType && filter.ownershipType?.length > 0) {
          var ownershipTypeSet = [];
          if (filter.ownershipType.includes("Null")) {
            ownershipTypeSet.push(
              { ownershipType: "" },
              { ownershipType: null },
              { ownershipType: { $exists: false } }
            );
          }

          const nonNullOptions3 = filter.ownershipType.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions3.length > 0) {
            ownershipTypeSet.push({ ownershipType: { $in: nonNullOptions3 } });
          }

          filter[`$and`].push({ $or: ownershipTypeSet });
          delete filter[`ownershipType`];
        } else {
          delete filter[`ownershipType`];
        }

        if (filter[`$and`]?.length <= 0) {
          // filter[`$and`] = [{}];
          delete filter[`$and`];
        }

        this.combined.portal =
          filter.p24Active ||
          filter.webActive ||
          filter.p24Inactive ||
          filter.webInactive
            ? { $or: [] }
            : null;

        if (filter.p24Active || filter.p24Inactive)
          this.combined.portal.$or.push({ website: { $ne: true } });

        if (filter.webActive || filter.webInactive)
          this.combined.portal.$or.push({ website: true });

        if (filter.webInactive || filter.p24Inactive)
          this.combined.portal.exclude = true;

        this.combined.portal;

        delete filter[`p24Active`];
        delete filter[`webActive`];
        delete filter[`p24Inactive`];
        delete filter[`webInactive`];

        var pinColor = null;

        this.forSaleTab2 = filter[`forSale`];
        this.toLetTab2 = filter[`toLet`];

        if (this.tab == 0) {
          if (filter[`forSale`]) pinColor = { $regex: "orange", $options: "i" };
          if (filter[`toLet`]) pinColor = { $regex: "green", $options: "i" };
          if (filter[`forSale`] && filter[`toLet`])
            pinColor = { $regex: "orange/half green", $options: "i" };

          if (pinColor) filter.pinColor = pinColor;
        }

        delete filter[`forSale`];
        delete filter[`toLet`];

        this.combined.properties = { ...filter };

        this.skipPropety = Object.values(this.combined.properties).length <= 0;

        this.fetchPropertiesFromBuildings();
      } catch (error) {
        console.error("Error fetching areas data:", error);
      } finally {
      }
    },
    async fetchPropertiesFromBuildings() {
      try {
        const bFilter = { ...this.buildingOptions };

        if (Object.values(bFilter).length > 0) {
          bFilter[`$and`] = [];
        }

        if (bFilter?.salePrice) {
          if (bFilter.salePrice[0] != 0 || bFilter.salePrice[1] != "Any") {
            bFilter.forSalePrice = {
              $gte:
                bFilter?.salePrice[0] != "0"
                  ? parseInt(bFilter?.salePrice[0])
                  : 0,
              $lte:
                bFilter?.salePrice[1] != "Any"
                  ? parseInt(bFilter?.salePrice[1])
                  : 9999999999,
            };
          }
        }
        delete bFilter[`salePrice`];

        if (bFilter.size) {
          bFilter.size = {
            $gte: bFilter.size?.min ? parseFloat(bFilter.size?.min) : 0,
            $lte: bFilter.size?.max
              ? parseFloat(bFilter.size?.max)
              : 99999999999,
          };
        } else {
          delete bFilter[`size`];
        }

        if (bFilter.buildingType && bFilter.buildingType?.length > 0) {
          var buildingTypeSet = [];
          if (bFilter.buildingType.includes("Null")) {
            buildingTypeSet.push(
              { buildingType: "" },
              { buildingType: null },
              { buildingType: { $exists: false } }
            );
          }

          const nonNullOptions = bFilter.buildingType.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions.length > 0) {
            buildingTypeSet.push({ buildingType: { $in: nonNullOptions } });
          }

          bFilter[`$and`].push({ $or: buildingTypeSet });
          delete bFilter[`buildingType`];
        } else {
          delete bFilter[`buildingType`];
        }

        if (bFilter.tags && bFilter.tags?.length > 0) {
          var tagsSet = [];
          if (bFilter.tags.includes("Null")) {
            tags.push(
              { tags: "" },
              { tags: null },
              { tags: { $exists: false } }
            );
          }

          const nonNullOptions2 = bFilter.tags.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions2.length > 0) {
            tagsSet.push({ tags: { $in: nonNullOptions2 } });
          }

          bFilter[`$and`].push({ $or: tagsSet });
          delete bFilter[`tags`];
        } else {
          delete bFilter[`tags`];
        }

        if (bFilter.grade && bFilter.grade?.length > 0) {
          var gradeSet = [];
          if (bFilter.grade.includes("Null")) {
            gradeSet.push(
              { grade: "" },
              { grade: null },
              { grade: { $exists: false } }
            );
          }

          const nonNullOptions3 = bFilter.grade.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions3.length > 0) {
            gradeSet.push({ grade: { $in: nonNullOptions3 } });
          }

          bFilter[`$and`].push({ $or: gradeSet });
          delete bFilter[`grade`];
        } else {
          delete bFilter[`grade`];
        }

        if (bFilter.greenRating && bFilter.greenRating?.length > 0) {
          var greenRatingSet = [];
          if (bFilter.greenRating.includes("Null")) {
            greenRatingSet.push(
              { greenRating: "" },
              { greenRating: null },
              { greenRating: { $exists: false } }
            );
          }

          const nonNullOptions4 = bFilter.greenRating.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions4.length > 0) {
            greenRatingSet.push({ greenRating: { $in: nonNullOptions4 } });
          }

          bFilter[`$and`].push({ $or: greenRatingSet });
          delete bFilter[`greenRating`];
        } else {
          delete bFilter[`greenRating`];
        }

        if (bFilter.occupiedBy && bFilter.occupiedBy?.length > 0) {
          var occupiedBySet = [];
          if (bFilter.occupiedBy.includes("Null")) {
            occupiedBySet.push(
              { occupiedBy: "" },
              { occupiedBy: null },
              { occupiedBy: { $exists: false } }
            );
          }

          const nonNullOptions5 = bFilter.occupiedBy.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions5.length > 0) {
            occupiedBySet.push({ occupiedBy: { $in: nonNullOptions5 } });
          }

          bFilter[`$and`].push({ $or: occupiedBySet });
          delete bFilter[`occupiedBy`];
        } else {
          delete bFilter[`occupiedBy`];
        }

        if (bFilter.highlights) {
          bFilter.highlights = { $in: bFilter.highlights };
        } else {
          delete bFilter[`highlights`];
        }

        if (bFilter.acquiredSource && bFilter.acquiredSource?.length > 0) {
          var acquiredSourceSet = [];
          if (bFilter.acquiredSource.includes("Null")) {
            acquiredSourceSet.push(
              { acquiredSource: "" },
              { acquiredSource: null },
              { acquiredSource: { $exists: false } }
            );
          }

          const nonNullOptions6 = bFilter.acquiredSource.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions6.length > 0) {
            acquiredSourceSet.push({
              acquiredSource: { $in: nonNullOptions6 },
            });
          }

          bFilter[`$and`].push({ $or: acquiredSourceSet });
          delete bFilter[`acquiredSource`];
        } else {
          delete bFilter[`acquiredSource`];
        }

        if (bFilter.listingBroker) {
          bFilter.listingBroker = { id: bFilter.listingBroker };
        } else {
          delete bFilter[`listingBroker`];
        }

        if (bFilter.activeBroker) {
          bFilter.activeBroker = { id: bFilter.activeBroker };
        } else {
          delete bFilter[`activeBroker`];
        }

        if (bFilter.listingDateFrom || bFilter?.listingDateTo) {
          bFilter.listingDate = {
            $gte: bFilter.listingDateFrom
              ? new Date(bFilter.listingDateFrom).getTime()
              : new Date("0").getTime(),
            $lte:
              (bFilter.listingDateTo
                ? new Date(bFilter.listingDateTo).getTime()
                : new Date().getTime()) + 86399999,
          };
        }
        delete bFilter[`listingDateFrom`];
        delete bFilter[`listingDateTo`];

        if (bFilter.unListingDateFrom || bFilter?.unListingDateTo) {
          bFilter.unListingDate = {
            $gte: bFilter.unListingDateFrom
              ? new Date(bFilter.unListingDateFrom).getTime()
              : new Date("0").getTime(),
            $lte:
              (bFilter.unListingDateTo
                ? new Date(bFilter.unListingDateTo).getTime()
                : new Date().getTime()) + 86399999,
          };
        }
        delete bFilter[`unListingDateFrom`];
        delete bFilter[`unListingDateTo`];

        if (!bFilter.onAuction) {
          delete bFilter[`onAuction`];
        }

        if (this.tab == 1) bFilter[`forSale`] = this.forSaleTab2;

        if (!bFilter.forSale) {
          delete bFilter[`forSale`];
        }

        if (bFilter[`$and`]?.length == 0) {
          delete bFilter[`$and`];
        }

        this.combined.buildings = { ...bFilter };
        this.fetchPropertiesFromUnits();

        if (Object.values(bFilter).length > 0) {
          this.finalBuildingFilters = { $and: [bFilter] };
        } else {
          this.finalBuildingFilters = {};
        }
      } catch (error) {
        console.error(
          "Error fetching foundPropertiesFromBuildings data:",
          error.message
        );
      } finally {
      }
    },

    async fetchPropertiesFromUnits() {
      try {
        const uFilter = { ...this.unitOptions };

        if (Object.values(uFilter).length > 0) {
          uFilter[`$and`] = [];
        }

        if (uFilter?.grossRent) {
          if (uFilter.grossRent[0] != 0 || uFilter.grossRent[1] != "Any") {
            uFilter.totalRental = {
              $gte:
                uFilter?.grossRent[0] != "0"
                  ? parseInt(uFilter?.grossRent[0])
                  : 0,
              $lte:
                uFilter?.grossRent[1] != "Any"
                  ? parseInt(uFilter?.grossRent[1])
                  : 9999999999,
            };
          }
        }
        delete uFilter[`grossRent`];

        if (uFilter.glaTotal) {
          uFilter.glaTotal = {
            $gte: uFilter.glaTotal?.min ? parseFloat(uFilter.glaTotal?.min) : 0,
            $lte: uFilter.glaTotal?.max
              ? parseFloat(uFilter.glaTotal?.max)
              : 99999999999,
          };
        } else {
          delete uFilter[`glaTotal`];
        }

        if (uFilter.acquiredSource && uFilter.acquiredSource.length > 0) {
          var acquiredSourceSet = [];
          if (uFilter.acquiredSource.includes("Null")) {
            acquiredSourceSet.push(
              { acquiredSource: "" },
              { acquiredSource: null },
              { acquiredSource: { $exists: false } }
            );
          }

          const nonNullOptions = uFilter.acquiredSource.filter(
            (type) => type !== "Null"
          );
          if (nonNullOptions.length > 0) {
            acquiredSourceSet.push({
              acquiredSource: { $in: nonNullOptions },
            });
          }

          uFilter[`$and`].push({ $or: acquiredSourceSet });
          delete uFilter[`acquiredSource`];
        } else {
          delete uFilter[`acquiredSource`];
        }

        if (uFilter.listingBroker) {
          uFilter.listingBroker = { id: uFilter.listingBroker };
        } else {
          delete uFilter[`listingBroker`];
        }

        if (uFilter.activeBroker) {
          uFilter.activeBroker = uFilter.activeBroker;
        } else {
          delete uFilter[`activeBroker`];
        }

        if (uFilter.listingDateFrom || uFilter?.listingDateTo) {
          uFilter.listingDate = {
            $gte: uFilter.listingDateFrom
              ? new Date(uFilter.listingDateFrom).getTime()
              : new Date("0").getTime(),
            $lte:
              (uFilter.listingDateTo
                ? new Date(uFilter.listingDateTo).getTime()
                : new Date().getTime()) + 86399999,
          };

          delete uFilter[`listingDateFrom`];
          delete uFilter[`listingDateTo`];
        } else {
          delete uFilter[`listingDateFrom`];
          delete uFilter[`listingDateTo`];
        }

        if (this.tab == 1) uFilter[`toLet`] = this.toLetTab2;

        if (uFilter.toLet) {
          // uFilter.deleted = { $ne: true };
          uFilter[`$and`].push({ deleted: { $ne: true } });
        }
        delete uFilter[`toLet`];

        if (uFilter.archivedDateFrom || uFilter?.archivedDateTo) {
          uFilter.deletedAt = {
            $gte: uFilter.archivedDateFrom
              ? new Date(uFilter.archivedDateFrom).getTime()
              : new Date("0").getTime(),
            $lte:
              (uFilter.archivedDateTo
                ? new Date(uFilter.archivedDateTo).getTime()
                : new Date().getTime()) + 86399999,
          };
          uFilter.deleted = true;
        }
        delete uFilter[`archivedDateFrom`];
        delete uFilter[`archivedDateTo`];

        if (uFilter[`$and`]?.length == 0) {
          delete uFilter[`$and`];
        }

        this.skipUnits = Object.values(uFilter).length <= 0;
        uFilter.deleted = uFilter?.deleted ? true : { $ne: true };
        this.combined.units = { ...uFilter };

        const checkRefs =
          this.isNonEmptyObject(this.skipUnits ? {} : this.combined.units) ||
          this.isNonEmptyObject(this.combined.buildings) ||
          this.isNonEmptyObject(this.combined.hqnames) ||
          this.isNonEmptyObject(this.combined.portal);

        // this.superProRefFilter = {};

        if (checkRefs) {
          this.superProRefFilter.units = this.skipUnits
            ? {}
            : { ...this.combined.units };
          this.superProRefFilter.buildings = { ...this.combined.buildings };
          this.superProRefFilter.hqnames = { ...this.combined.properties };
          this.superProRefFilter.portal = { ...this.combined.portal };
        } else {
          this.superPropertyFilter = { ...this.combined.properties };
        }

        this.finalUnitFilters = { $and: [uFilter] };
      } catch (error) {
        console.error(
          "Error fetching foundBuildsFromUnits data:",
          error.message
        );
      } finally {
      }
    },
  },
  watch: {
    propertyOptions: {
      handler(newVal, oldVal) {
        this.fetchPropertiesFilters();
      },
      deep: true,
    },
    buildingOptions: {
      handler(newVal) {
        this.fetchPropertiesFilters();
      },
      deep: true,
    },
    unitOptions: {
      handler(newVal) {
        this.fetchPropertiesFilters();
      },
      deep: true,
    },
    tab(newVal) {
      if (newVal == 1) {
        this.$apollo.queries.properties.stopPolling();
        this.getProps = true;
      }
    },
    superPropertyFilter: {
      handler(newVal) {
        this.$apollo.queries.properties.stopPolling();
        this.getProps = true;
      },
      deep: true,
    },
    superProRefFilter: {
      handler(newVal) {
        this.$apollo.queries.properties.stopPolling();
        this.$apollo.queries.propertiesFromReferences.stopPolling();
        this.getPropsFromRef = true;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    // this.fetchPropertiesFilters();
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.property-search-page {
  position: relative;
}

.map-toggle-btn {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 60%;
  opacity: 0.7;
}

.map-toggle-btn:hover {
  opacity: 1;
}
</style>
